import { apiClient } from '../api/axios';
import { DASHBOARD_ENDPOINT } from '@/config/endpoints';
import { DashboardData } from '@/pages/dashboard/DashboardData';

export const fetchDashboardData = async (): Promise<DashboardData> => {
  return await apiClient.get<DashboardData>(DASHBOARD_ENDPOINT);
};
